/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Refund_Exceeds_RefundableInputs */

const vi_error_refund_exceeds_refundable = /** @type {(inputs: Error_Refund_Exceeds_RefundableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền hoàn vượt số khách đã trả thừa trên đơn.`)
};

/**

* @param {Error_Refund_Exceeds_RefundableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_refund_exceeds_refundable = /** @type {((inputs?: Error_Refund_Exceeds_RefundableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Refund_Exceeds_RefundableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_refund_exceeds_refundable(inputs)
});